import { $, $$, isTablet } from '@utils';

function init() {
  if (!$('[data-au-card-video]')) return;

  addEventListeners();
  if (isTablet.matches) setAutoplay();
}

function addEventListeners() {
  $$('[data-au-card-video]').forEach((video) => {
    const containerCard = video.closest('article');

    containerCard.addEventListener('mouseover', () => video.play());
    containerCard.addEventListener('mouseleave', () => video.pause());
  });
}

function setAutoplay() {
  $$('[data-au-card-video]').forEach((video) => {
    video.setAttribute('autoplay', '');
  });
}

export default { init };
